import React from 'react'

const NotFoundProduct = () => {
  return (
    <div className='not-found'>
        <p>Rất tiếc, không tìm thấy sản phẩm phù hợp với lựa chọn của bạn</p>
    </div>
  )
}

export default NotFoundProduct